import { ref, useContext } from '@nuxtjs/composition-api'
import { getNextDayDate } from '~/lib/utilities/datetime'
import { AgeCheck } from '~/types/common'

const COOKIE_AGE_CHECK_KEY = 'gezondheidswinkel_cookie_age_check_status'

export function useCookieAgeCheck() {
  const {
    app: { $storage },
  } = useContext()

  const visible = ref(false)

  const setCookie = (permission: AgeCheck) => {
    $storage.setCookie(COOKIE_AGE_CHECK_KEY, permission, {
      path: '/',
      expires: getNextDayDate(),
    })
  }

  const getPermissionStatus = (): AgeCheck => {
    return $storage.getCookie(COOKIE_AGE_CHECK_KEY) || AgeCheck.Prompt
  }

  const open = () => {
    visible.value = true
  }

  const close = () => {
    visible.value = false
  }

  const onAccept = () => {
    setCookie(AgeCheck.Confirmed)
    close()
  }

  const onRefuse = () => {
    setCookie(AgeCheck.Denied)
    close()
  }

  return {
    visible,
    getPermissionStatus,
    open,
    close,
    onAccept,
    onRefuse,
  }
}
